import { Colors } from '../consts/Colors.js';
import ButtonArrow from './buttons/ButtonArrow.js';

export default class Menu extends Phaser.GameObjects.Container {
    constructor(scene) {
        super(scene, 0, 0);
        scene.add.existing(this);
        this.scene = scene;

        this.rectBack = this.scene.add.rectangle(0, 0, 1920, 1080, Colors.Elmt.DarkBlue, 0.5).setOrigin(0).setAlpha(0)
        this.add(this.rectBack);
        this.trigger = this.scene.add.image(1780, 60, 'ctaMenu').setOrigin(0.5);
        this.add(this.trigger);

        this.trigger.setInteractive();
        this.trigger.on('pointerup', () => {
            this.trigger.setAlpha(0);
            // this.rectBack.setAlpha(1);
            this.scene.tweens.add({
                targets: [this.menuContainer],
                duration: 500,
                ease: 'Cubic.easeInOut',
                x: 1490,
                onComplete: () => {
                }
            });
            this.scene.tweens.add({
                targets: [this.rectBack],
                duration: 200,
                ease: 'Cubic.easeInOut',
                alpha: 1,
                onComplete: () => {
                }
            });
        });

        this.menuContainer = this.scene.add.container(1920, 0)
        this.add(this.menuContainer);
        this.back = this.scene.add.rectangle(0, 0, 430, 1080, Colors.Elmt.Blue).setOrigin(0)
        this.menuContainer.add(this.back);
        this.closeBtn = this.scene.add.image(400, 50, 'closeBtn').setOrigin(0.5).setInteractive({ useHandCursor: true });
        this.menuContainer.add(this.closeBtn);
        this.closeBtn.on('pointerup', () => {
            this.scene.tweens.add({
                targets: [this.menuContainer],
                duration: 500,
                ease: 'Cubic.easeInOut',
                x: 1920,
                onComplete: () => {
                    this.trigger.setAlpha(1);
                    this.rectBack.setAlpha(0);
                }
            });
              this.scene.tweens.add({
                targets: [this.rectBack],
                duration: 200,
                ease: 'Cubic.easeInOut',
                alpha: 0,
                onComplete: () => {
                }
            });
        });

        this.addTitlte(170, "ACCUEIL");
        this.addBtn(210, "Niveau de difficulté", 'Intro');
        this.addTitlte(295, "MISSION 1 : POSIDONIE");
        this.addBtn(340, "Activité", 'Activite1');
        this.addBtn(370, "Vidéo", 'Activite1Video');
        this.addTitlte(455, "MISSION 2 : RORQUAL PERDU");
        this.addBtn(500, "Activité", 'Activite2');
        this.addBtn(530, "Vidéo", 'Activite2Video');
        this.addTitlte(615, "MISSION 3 : QUI MANGE QUI ?");
        this.addBtn(660, "Activité", 'Activite3');
        this.addBtn(690, "Vidéo", 'Activite3Video');
        this.addTitlte(780, "MISSION 4 : MENACE MYSTÈRE");
        this.addBtn(825, "Activité", 'Activite4');
        this.addBtn(855, "Vidéo", 'Activite4Video');
        this.addTitlte(940, "KARAOKÉ");
        this.addBtn(985, "Vidéo", 'Karaoke');



    }

    addBtn(y, txt, nextScene) {
        let btn = this.scene.add.rexTagText(130, y, txt, {
            fontSize: "20px",
            fontFamily: "Binx",
            align: "left",
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            wordWrap: { width: 400 },
        })
        btn.setOrigin(0, 0.5);
        btn.setInteractive({ useHandCursor: true });
        btn.on('pointerover', () => {
            btn.setScale(1.1);
        });
        btn.on('pointerout', () => {
            btn.setScale(1);
        });
        btn.on('pointerup', () => {
            this.scene.scene.start(nextScene);
        });
        this.menuContainer.add(btn);
        return btn;

    }

    addTitlte(y, txt) {
        let title = this.scene.add.rexTagText(80, y, txt, {
            fontSize: "32px",
            fontFamily: "WWF",
            align: "left",
            color: Colors.Text.White,
            backgroundColor: 'transparent',
            wordWrap: { width: 400 },
        })
        title.setOrigin(0, 0.5);
        this.menuContainer.add(title);
    }
}
